import { useSignedS3Url } from '@common/hooks/useSignedS3Url';
import { IWebView } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import { isEmpty, pick } from 'lodash';
import React, { FC, useMemo } from 'react';
import { Image as RNImage, Platform, View } from 'react-native';
import { WebView } from 'react-native-webview';
import createStyles from './style';

const CusWebView: FC<IWebView> = (attributes) => {
  const styles = createStyles(attributes);
  const uri: string = useMemo(
    () => getValueBindingComponent(attributes, 'uri'),
    [attributes]
  );

  // A file uploaded through the File element is stored as a pre-signed S3 URL
  // valid for five minutes, so a `uri` bound to a saved record field is usually
  // expired by the time the screen is reopened and the frame renders S3's
  // "Request has expired" XML instead of the document. Sign again at render.
  const resolved = useSignedS3Url(uri);

  const resolvedUri = resolved.value;
  const validLink = isEmpty(resolvedUri.match(/^((http|https):\/\/)/));
  const check = validLink ? `https://${resolvedUri}` : resolvedUri;

  const expression =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);
  if (!uri) return <View style={styles.container} />;
  if (!resolved.ready) return <View style={styles.container} />;

  if (!resolvedUri.match(regex)) {
    return (
      <View style={styles.container}>
        <RNImage
          source={{
            uri: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5JMgzHBTZO_V1iTlq6Fr-Lywo85GD65RMtOFU1GgUjOhsw-DoYI4V0nzG99A9wqSduZU&usqp=CAU',
          }}
          style={{
            ...pick(attributes, ['width', 'height']),
          }}
          resizeMode={'contain'}
        />
      </View>
    );
  }
  if (Platform.OS === 'web') {
    return (
      <View style={styles.container}>
        <iframe
          src={check}
          style={{
            ...pick(attributes, ['width', 'height']),
            border: 'unset',
          }}
          allow="microphone; camera; fullscreen; geolocation; payment"
          allowFullScreen={true}
          title="Click"
        />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <WebView
        style={styles.container}
        source={{ uri: check as any }}
        mediaPlaybackRequiresUserAction={true}
        allowsInlineMediaPlayback={true}
        contentInsetAdjustmentBehavior={'automatic'}
        nestedScrollEnabled={true}
        renderError={() => {
          return <View style={styles.errorRender} />;
        }}
      />
    </View>
  );
};

export default CusWebView;
